<template>
    <div class>
        <template v-for="(item,i) in menuList" >
            <ul v-if="item.children && item.children.length" class="sport_performance_item mb20" :key="i">
                <li class="performance_item_header Disp_AC" v-if="showTitle">
                    <span class="performance_item_name SysFontM">{{item['desc'+$lang]}}</span>
                    <cl-svg-icon
                        v-if="showIcon"
                        icon-class="data_detail"
                        color="#81818A"
                        style="font-size: 22px;"
                        @click.native="goRoute(item, 'detail')"
                    ></cl-svg-icon>
                </li>
                <li v-for="child in item.children" :key="child.route || child.key">
                    <div
                        v-if="!child.hidden"
                        class="performance_item_child"
                        @click="goRoute(child)"
                    >
                        <img
                            class="child_img"
                            :src="child.img"
                            :style="'box-shadow: 0px 6px 6px '+child.color+'22'"
                        />
                        <p class="child_name">{{child['desc'+$lang] || child['name' + $lang]}}</p>
                    </div>
                </li>
            </ul>
        </template>
    </div>
</template>
<script>
/**
 * ComponentName: menu 导航
 * Created Date:2022/5/15
 * Author: zhangch
 * Modify: dongyu·zhu 2022/5/16
 * 组件说明：
 * eg:
 * <cl-item-list></cl-item-list>
 */
export default {
    name: 'cl-item-list',
    data () {
        return {

        };
    },
    props: {
        menuList: {
            type: Array,
            default: () => []
        },
        showIcon: {
            type: Boolean,
            default: true
        },
        // 是否单独处理单击事件
        handleClick:{
            type: Boolean,
            default: false
        },
        // 是否显示title
        showTitle: {
            type: Boolean,
            default: true,
        }
    },
    methods: {
        goRoute (item, flag) {
            // XXX：gps和rpe详情先写死
            if (flag === 'detail' && ['/report/sport-performance/gps/index', '/report/sport-performance/rpe/index'].includes(item.route)) {
                if (item.route === '/report/sport-performance/gps/index') {
                    this.$router.push({
                        path: '/report/sport-performance/gps/detail',
                    })
                    return
                } else if (item.route === '/report/sport-performance/rpe/index') {
                    this.$router.push({
                        path: '/report/sport-performance/rpe/rpe-detail',
                    })
                    return
                }
            }
            if(this.handleClick){
                this.$emit('handleClick',item)
            }else{
                this.$router.push({
                    path: item.route,
                })
            }
            
        },
        // getImg(src){
        //     return require('@i/performance/'+src)
        // }
    }
}
</script>
<style lang="scss" scoped>
.sport_performance_item {
    color: #000;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding: 0 24px 16px;
    box-sizing: border-box;
    background: #fff;
    border-radius: $base-border-radius-mini;
    li:nth-child(8n){
        .performance_item_child{
            margin-right: 0;
        }
    }
}
.performance_item_header {
    width: 100%;
    justify-content: space-between;
    height: 54px;
    border-bottom: 1px solid #f3f5f9;
    .performance_item_name {
        font-size: $base-fontSize-16;
        color: $base-font-major;
    }
}
.performance_item_child {
    width: 131px;
    height: 122px;
    margin: 16px 32px 0 0;
    text-align: center;
    
    .child_img {
        width: 50px;
        height: 50px;
        margin: 14px auto 8px;
        box-shadow: 0px 6px 6px rgba(150, 70, 255, 0.12);
        border-radius: 6px;
        cursor: pointer;
    }
    .child_name {
        width: 100%;
        text-align: center;
        white-space: break-spaces;
        font-size: $base-fontSize-14;
        line-height: 20px;
        color: $base-font-major;
    }
}
</style>
